import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

const Item = styled(Button)(({ theme }) => ({
    width: '20vw',
    height: '16vmin',
    fontSize: '4vmin'
}));

const BoxItem = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
}));

export default function ModuleHome() {
    const navigate = useNavigate();

    const linkHandler = (to) => {
        navigate(to)
    }

    return (
        <BoxItem>
            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" flexWrap="wrap"
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', height: '100%' }}
            >
                <Item variant='contained' onClick={() => linkHandler('/module/integratedControlView')}>통합관제</Item>
                <Item variant='contained' onClick={() => linkHandler('/module/roadTrafficView')}>도로소통</Item>
                <Item variant='contained' onClick={() => linkHandler('/module/trafficSafetyView')}>교통안전</Item>
                {/* <Item variant='contained' onClick={() => linkHandler('/module/trafficSafetyViewDetail')}>교통안전상세</Item> */}
                <Item variant='contained' onClick={() => linkHandler('/module/signalOperationViewTest')}>신호운영메인</Item>
                <Item variant='contained' onClick={() => linkHandler('/module/signalOperationView')}>신호운영(긴급차량)</Item>
                <Item variant='contained' onClick={() => linkHandler('/module/busOperationView')}>버스운행</Item>
                <Item variant='contained' onClick={() => linkHandler('/module/futureTransportationView')}>미래교통</Item>

            </Stack>
            <Typography sx={{position:'absolute', left:0, top:0, m:1}}>* 월컨트롤러(10400x1800), 데이터 모듈(5200x1800)</Typography>
        </BoxItem>
    );
}